import { useNavigate } from 'react-router-dom';

export function PrivacyPage() {
  const navigate = useNavigate();

  return (
    <div className="max-w-4xl mx-auto px-4 py-8">
      {/* Back Button */}
      <button
        onClick={() => navigate(-1)}
        className="flex items-center gap-2 text-gray-600 hover:text-gray-900 mb-6 transition-colors"
      >
        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
        </svg>
        Back
      </button>

      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-8">
        <h1 className="text-3xl font-bold text-gray-900 mb-2">Privacy Policy</h1>
        <p className="text-gray-600 mb-8">Effective Date: December 5th, 2025</p>
        <p className="text-gray-600 mb-8">Platform: The Daily Do ("we," "our," "us")</p>

        <div className="prose prose-gray max-w-none space-y-6">
          {/* Section 1 */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">1. Information We Collect</h2>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li><strong>Information you provide:</strong> When you create an account, submit an event, or sign up for updates (e.g., name, email, event details).</li>
              <li><strong>Automatic information:</strong> Technical details such as IP address, browser type, cookies, and usage data.</li>
              <li><strong>Third-party information:</strong> If you use integrated services (e.g., social logins, ticketing platforms).</li>
            </ul>
          </section>

          {/* Section 2 */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">2. How We Use Your Information</h2>
            <p className="text-gray-700 leading-relaxed mb-3">We use your information to:</p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Provide and improve the Platform.</li>
              <li>Publish and promote events you submit.</li>
              <li>Communicate with you (updates, notifications, promotional content if opted-in).</li>
              <li>Maintain security and prevent misuse.</li>
            </ul>
          </section>

          {/* Section 3 */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">3. Event Listings & Public Content</h2>
            <p className="text-gray-700 leading-relaxed">
              Event submissions are generally public. Any details you share in an event listing (such as event title, description, time, location) may be visible to anyone using the Platform.
            </p>
          </section>

          {/* Section 4 */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">4. Sharing of Information</h2>
            <p className="text-gray-700 leading-relaxed mb-3">We may share information with:</p>
            <ul className="list-disc pl-6 space-y-2 text-gray-700">
              <li>Service providers that help operate the Platform (e.g., hosting, analytics).</li>
              <li>Legal authorities if required by law or to protect rights and safety.</li>
              <li>Third-party sites when you voluntarily connect or link accounts.</li>
            </ul>
            <p className="text-gray-700 leading-relaxed mt-3">
              We do not sell your personal information to advertisers or marketers.
            </p>
          </section>

          {/* Section 5 */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">5. Cookies & Tracking</h2>
            <p className="text-gray-700 leading-relaxed">
              We use cookies and similar technologies to improve user experience, track activity, and personalize content. You can manage cookie preferences through your browser.
            </p>
          </section>

          {/* Section 6 */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">6. Data Security</h2>
            <p className="text-gray-700 leading-relaxed">
              We take reasonable measures to protect your data, but no system is fully secure. You use the Platform at your own risk.
            </p>
          </section>

          {/* Section 7 */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">7. Children's Privacy</h2>
            <p className="text-gray-700 leading-relaxed">
              The Platform is not intended for children under 18. We do not knowingly collect personal data from children.
            </p>
          </section>

          {/* Section 8 */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">8. Your Rights</h2>
            <p className="text-gray-700 leading-relaxed">
              Depending on your jurisdiction, you may have the right to access, update, or delete your personal data. Please contact us if you would like to exercise these rights.
            </p>
          </section>

          {/* Section 9 */}
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-3">9. Changes to This Policy</h2>
            <p className="text-gray-700 leading-relaxed">
              We may update this Privacy Policy from time to time. Continued use of the Platform means you accept the updated policy.
            </p>
          </section>
        </div>

        {/* Contact Section */}
        <div className="mt-8 pt-8 border-t border-gray-200">
          <p className="text-gray-600 text-sm">
            If you have any questions about this Privacy Policy, please contact us.
          </p>
        </div>
      </div>
    </div>
  );
}
